import { z } from 'my-zod'
import { customersModel } from '.'

export const updateCustomerCustomerView = customersModel
  .pick({
    firstName: true,
    lastName: true,
    helmetSize: true,
    email: true,
    addressLine1: true,
    addressLine2: true,
    city: true,
    state: true,
    postalCode: true,
    primaryPhone: true,
    country: true,
    driverLicenseCountry: true,
    driverLicenseState: true,
    driverLicenseExpirationDate: true,
    driverLicenseNumber: true,
    DOB: true,
    market: true,
    marketingOptIn: true,
    ssoEmail: true,
    hasMotorcycleLicense: true
  })
  .partial()
  .merge(
    customersModel.pick({
      id: true
    })
  )

export type updateCustomerCustomerView = z.infer<typeof updateCustomerCustomerView>
